const getRisk = (riskLevel?: number) => {
    if (!riskLevel && !(riskLevel === 0)) return '';

    switch (true) {
        case riskLevel >= 5:
            return 'Høy';
        case riskLevel >= 3:
            return 'Medium';
        default:
            return 'Lav';
    }
};

export default getRisk;
